<script>
    export default {
        props: ['start', 'end'],
        data() {
            return {
                time: {
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                }
            }
        },
        mounted() {
            this.interval = setInterval(() => {
                this.refresh();
            }, 1000)
        },
        methods: {
            refresh() {
                let endTime = this.end.split(':');
                let from;

                if (this.start == 'now') {
                    from = moment();
                } else {
                    let startTime = this.start.split(':');
                    from = moment().hour(startTime[0]).minute(startTime[1]);
                }

                let end = moment().hour(endTime[0]).minute(endTime[1]);


                let difftime = moment.duration(end.diff(from, 'seconds') * 1000);

                this.time = {
                    hours: difftime.hours('HH'),
                    minutes: difftime.minutes('mm'),
                    seconds: difftime.seconds('ss'),
                };
            }
        },
        render() {
            return this.$scopedSlots.default(
                this.time
            );
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/CountDown.vue